import {data} from './data';

const getTranslations = async function(text, languages, defaultLanguage) {
    if(!Array.isArray(languages))
        languages = [languages];
    if(!text) {
        let returnArr = [];
        languages.forEach(lg => {
            if(lg !== defaultLanguage) returnArr.push({text: '', language: lg});
        });
        return returnArr;
    }
    return await data.translateText(encodeURIComponent(text), languages.filter(lng => lng !== defaultLanguage), defaultLanguage);
    // let div = document.createElement('div');
    // div.innerHTML = text;
    // const resp = await data.translateText(div.innerText, languages.filter(lng => lng !== 'English'));
    // div.innerText = resp.text;
    // return {
    //     language: resp.language,
    //     text: div.innerHTML
    // };
}

const getTranslatedText = function(language, jsonObj) {
    if(!jsonObj)
        return '';
    const ms = jsonObj.find(ms => ms.language === language);
    return ms ? ms.text : '';
}

const addTranslations = async function(jsonObj, defaultText, languages, defaultLanguage) {
    jsonObj = [];
    jsonObj.push({
        text: defaultText,
        language: defaultLanguage
    });
    if(languages.length > 1 && defaultText) {
        jsonObj.push(...await this.getTranslations(defaultText, languages, defaultLanguage));
    }
    return jsonObj;
}

const removeLanguageFromField = function(jsonField, language) {
    var index = jsonField.findIndex(search => search.language === language);
    if(index >= 0)
        jsonField.splice(index, 1);
}

const addTranslationToField = async function(jsonObj, language, defaultLanguage, replaceIfExists = false) {
    if(!jsonObj) return;

    var currentText = await getTextForLanguage(jsonObj, language);
    if(currentText && replaceIfExists)
        Object.assign(
            jsonObj.find(tx => tx.language === language), 
            await translation.getTranslations(getTextForLanguage(jsonObj, defaultLanguage), language, defaultLanguage)
        )
    else if(currentText === '')
        return jsonObj.push(...await translation.getTranslations(getTextForLanguage(jsonObj, defaultLanguage), language, defaultLanguage));    
}

const getTextForLanguage = function(jsonField, language) {
    if(!jsonField) return '';
    var field = jsonField.find((search) => search.language === language);
    return field != null && field.text != null ? field.text : '';
}

const setTextForLanguage = function(field, language, jsonFieldName, text) {
    if(!field[jsonFieldName] || !field[jsonFieldName].length)
        field[jsonFieldName] = [{
            language: language,
            text: text
        }];
    else {
        var localField = field[jsonFieldName].find((search) => search.language === language);
        localField.text = text;
    }
}

const translateMediaProperty  = async function(mediaPropertyId, languages) {
    if(!mediaPropertyId || mediaPropertyId === 0) return;
    var mp = await data.getMediaProperty(mediaPropertyId);
    var text = translation.getTextForLanguage(mp.configuration.textJson, mp.defaultLanguage);

    for(var i = 0; i < languages.length; i++) {
        if(!mp.languages.includes(languages[i])) {
            mp.languages.push(languages[i]);
            mp.configuration.textJson.push(...await translation.getTranslations(text, languages[i], mp.defaultLanguage));
        }
    }

    await data.saveMediaProperty(mp);
}

export const translation = {
    getTranslations,
    getTranslatedText,
    addTranslations,
    translateMediaProperty,
    addTranslationToField,
    getTextForLanguage,
    setTextForLanguage,
    removeLanguageFromField
}